import { DialogTitle } from '@headlessui/react'
import React from 'react'

import './Title.scss'
import classy from 'shared/utils/classy'

export type ModalTitlePosition = 'left' | 'center'

export interface ModalTitleProps {
  children: React.ReactNode
  position?: ModalTitlePosition
  'data-testid'?: string
}

const ModalTitle = React.memo(
  ({
    children,
    position = 'left',
    'data-testid': dataTestId = 'modal-title',
  }: ModalTitleProps) => {
    return (
      <DialogTitle
        className={classy('ModalTitle', `ModalTitle--${position}`)}
        data-testid={dataTestId}
      >
        {children}
      </DialogTitle>
    )
  },
)

ModalTitle.displayName = 'Modal.Title'

export default ModalTitle
